'use client'

import { useLingui } from '@lingui/react'
import * as React from 'react'

import { GridSection } from '@/components/marketing/fragments/grid-section'
import RadialOrbitalTimeline from '@/components/ui/radial-orbital-timeline'
import { StarBorder } from '@/components/ui/star-border'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { SiteHeading } from '../fragments/site-heading'
import { msg } from '@lingui/core/macro'

export function Ecosystem(): React.JSX.Element {
  const { i18n } = useLingui()
  return (
    <GridSection>
      <section id='ecosystem' className='bg-diagonal-lines'>
        <div className='flex flex-col gap-24 bg-background py-20 md:py-24 lg:mx-12 lg:border-x'>
          <div className='container px-4 md:px-6 rounded-3xl relative'>
            <SiteHeading
              badge={msg`Projects`}
              title={msg`Blockchain Products`}
              description={msg`Discover strategic projects that have solidified our expertise in delivering modern technology solutions, partnering with clients on their comprehensive digital transformation journey.`}
            />
            <RadialOrbitalTimeline />
            <div className='flex justify-center pt-10'>
              <StarBorder rounded='rounded-full' className='h-12 px-8 group'>
                {i18n._('View all projects')}
                <motion.span
                  initial={{ x: 0 }}
                  whileHover={{ x: 5 }}
                  transition={{ type: 'spring', stiffness: 400, damping: 10 }}
                >
                  <ArrowRight className='ml-2 h-4 w-4 transition-transform group-hover:translate-x-1' />
                </motion.span>
              </StarBorder>
            </div>
          </div>
        </div>
      </section>
    </GridSection>
  )
}
